import React from 'react';
import PropTypes from 'prop-types';
import { Trans } from 'react-i18next';
import { WeezHeader, Button, EmptyCard } from '@weezevent/nacre';
import ImageEmptyCard from '../../images/image_empty_error.png';

export default function MemberSpace({ menhirUrl }) {
    return (
        <div>
            <WeezHeader title={<Trans i18nKey="ticket.member_space.title" />} />
            <EmptyCard
                title={<Trans i18nKey="empty.title" />}
                subTitle={<Trans i18nKey="empty.subtitle" />}
                image={ImageEmptyCard}
                cta={<Button primary label={<Trans i18nKey="empty.cta" />} as="a" href={menhirUrl} />}
            />
        </div>
    );
}

MemberSpace.propTypes = {
    menhirUrl: PropTypes.string.isRequired
};
